import api from '../../api';
import { TMutateTokenBody } from './token.types';

export const tokenEndpoint = '/bookie/promos/token/token';

export async function mutateToken(body: TMutateTokenBody) {
  const res = await api.post(tokenEndpoint, body);
  return res;
}
